import { matchPath } from "react-router-dom";

export const KIOSK_PATH = "/events/check-in/kiosk";

// The other two check-in stations (docs/design/SURFACES.md, K1: a landscape tablet). The routes in
// App.tsx use these constants, so the list below cannot drift from them.
export const GENERAL_CHECK_IN_PATH = "/events/check-in";
export const KIDS_CHECK_IN_PATH = "/kids-check-in";

/**
 * True for every URL the kiosk <Route> renders for. Uses the router's own matcher with its
 * defaults (case-insensitive, trailing slash allowed) so the theme enforcement cannot drift
 * from the route. index.html carries a regex copy for the pre-React splash.
 */
export function isKioskPathname(pathname: string): boolean {
  return matchPath({ path: KIOSK_PATH, end: true }, pathname) !== null;
}

/**
 * True for every check-in station: the kiosk and the two stations beside it. They are touch surfaces
 * (DECISIONS.md D1: buttons and fields are 44px "below 1024px and on kiosks"), so a landscape tablet at
 * 1024px or wider keeps the touch size. This is not `isKioskPathname`: only the check-in kiosk is always
 * light (DARK_MODE.md), so the other two stations take the touch size and keep the viewer's theme (#8032).
 */
export function isTouchStationPathname(pathname: string): boolean {
  return [KIOSK_PATH, GENERAL_CHECK_IN_PATH, KIDS_CHECK_IN_PATH].some(
    (path) => matchPath({ path, end: true }, pathname) !== null,
  );
}
